import {Bank} from "../../../../resources/bank"
import {messageTypes} from "./types"
import * as yup from "yup"

export default function validationSchema(banks: Bank[]) {
	yup.object().shape({
		messageType: yup
			.string()
			.oneOf(Object.keys(messageTypes), "Please select a valid message type")
			.required("Please select a message type"),
		originalMessageDate: yup.string().required("Please enter the original message date"),
		originalMessageId: yup
			.string()
			.required("Please enter the original message ID")
			.max(22, "Original message ID should be at most 22 characters long"),
		bank: yup
			.string()
			.oneOf(
				banks.map((b) => b.id.toString()),
				"Please select a valid bank"
			)
			.required("Please select a bank"),
		message: yup.string().required("Please enter the message"),
	})
}
